import { Component, OnInit } from '@angular/core';
import { IdiomasServiceN35 } from 'app/main/wizard-n35/services/idiomas.service';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup,  NgForm, FormControl,  Validators } from '@angular/forms';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import { fuseAnimations } from '@fuse/animations';
import { PdfMakeWrapper, Txt, Table, Img, Columns } from 'pdfmake-wrapper';
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import *  as $ from 'jquery';
import * as jspdf from 'jspdf';
import html2canvas from 'html2canvas';
import { AuthService } from 'app/auth/auth.service';
import { DATOS_API } from 'app/auth/auth.datos';
import * as backInter from 'app/auth/auth-data.model';
import { timestamp } from 'rxjs/operators';
import { lang_certificar } from 'app/idiomas/i18n/encuestador35/encuestador35.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
@Component({
  selector: 'app-pdfreporte',
  templateUrl: './pdfreporte.component.html',
  styleUrls: ['./pdfreporte.component.scss'],
  animations : fuseAnimations
})
export class PdfreporteComponent implements OnInit {
  data:any;
  arrayTodoList: any;
  slug    : '/NOM35/reporte-ct/';
  ruta:any;
  id:any;
  Incisos: Array<any> = [];
  IncisosUrl: Array<any> = [];
  DescripcionIncisos: Array<any> = [];
  idEmpresa : any; totalColaboradores:any; fechaProducto:any;
  nombreCT:any;
  empresaPadre:any;
  pathTmpFiles= "http://35.232.140.117/surveyadministrator/backend/";
  tipoReporte:any; // 1 es menos de 5 y 2 mas de 50
  form: FormGroup;
  rutaAyuda:any;
  tipo35_tmp:any;
  constructor(
    private idiomasService: IdiomasServiceN35,
    private activatedRoute : ActivatedRoute,
    public authService: AuthService,
    private _formBuilder: FormBuilder,
    private router: Router, public snackBar: MatSnackBar,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
  ) {
    lang_certificar.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    this.activatedRoute.params.subscribe(params => {
      this.idEmpresa = params['id'];
      this.fechaProducto = params['fecha'];
      this.totalColaboradores = params['colaboradores'];
      this.nombreCT = params['nombreCT'];
      this.empresaPadre=params['empresaPadre'];
      this.rutaAyuda="/NOM35/reporte-ct/"+this.fechaProducto+'/'+this.fechaProducto+'/'+this.idEmpresa+'/'+this.nombreCT+'/'+this.empresaPadre
      //this.router.navigate(['/NOM35/reporte-ct/',this.productoCertificar.fechaNorma35,this.centrosTrabajo.centros[index].totalColaboradores,idEnterprise,nombreCT,this.empresaPadre.empresaPadre],);
    })
    console.log("nivel de usuario");
    console.log(localStorage.getItem('tipo35_tmp'));
    this.tipo35_tmp=localStorage.getItem('tipo35_tmp');
  }

  ngOnInit() {
    this.getAllTask (this.fechaProducto,this.totalColaboradores,this.idEmpresa);
    this.getImagenLogo(this.empresaPadre);
    if(this.totalColaboradores<50){
      this.tipoReporte=1;
    }else{
      this.tipoReporte=2;
    }
  }


  indice() {
    var elmnt = document.getElementById("obj");
    elmnt.scrollIntoView();
  }

  indice2(tipo:any) {
    console.log("Tipo "+tipo);
    var elmnt = document.getElementById(""+tipo);
    elmnt.scrollIntoView();
  }


  idSeccion:any;
  private getAllTask (fecha,totalcolaboradores,idempresa){
    this.data = {
      fechaDocumentador: fecha
    }
    var fechaTask;
    this.idiomasService.geTodoListCT(this.data,idempresa).subscribe( (data : any)=>{
        console.log(data);
        this.arrayTodoList = data.secciones;
        console.log(this.arrayTodoList);
          if(totalcolaboradores>50){
            // El index 1 es encuesta de 16 a 50
            this.arrayTodoList.splice(1,1);
          }else{
            //El index 2 es el de más de 50
            this.arrayTodoList.splice(2,1);
          }
          for(var i=0; i < this.arrayTodoList.length; i++){
            //this.getSeccion(this.arrayTodoList[i].nombreSeccion,i);
            this.getSeccion(this.arrayTodoList[i].nombreSeccion,i);
              for(var k=0; k < this.arrayTodoList[i].tareas.length; k++){
                fechaTask=this.arrayTodoList[i].tareas[k].fechaCreacion.toString();
                this.arrayTodoList[i].tareas[k].fechaCreacion=fechaTask.substr(2,8);
              }
          }
    });
  }
  titleCantidad:Array<any> = [];
  primaryAcortador(idseccion,idTarea,archivoid,url){
    this.data = {
      seccionId : idseccion,
      tareaId: idTarea,
      archivoId: archivoid,
      fechaDocumentador: this.fechaProducto,
      acortador: url
    };
    this.idiomasService.updatePrimaryFile(this.data).subscribe( (data : any) => {
      console.log("Respuesta de acortador");
      console.log(data);
    });

  }
  private getSeccion (nombreseccion,pos){
    let pathTmp:any;
    switch(nombreseccion) {
      case "5.2 Identificar y analizar los factores de riesgo psicosocial": {
        this.titleCantidad[pos]="";
        this.IncisosUrl[pos]="incisoA";
        this.Incisos[pos]="a)	Evidencias documentales de la política de prevención de riesgos psicosociales";
        this.DescripcionIncisos[pos]="Los siguientes documentos sirven como evidencia de que se cuenta con una política que cumple con los incisos del punto 5.1 y las evidencias pertinentes para su implantación, mantenimiento y difusión.";
        break;
      }
      case "5.3 Identificar y analizar los factores de riesgo psicosocial": {
        this.titleCantidad[pos]='Para centros de trabajo con menos de 50 colaboradores';
        this.IncisosUrl[pos]="incisoB";
        this.Incisos[pos]="b)	Información del cuestionario aplicado";
        this.DescripcionIncisos[pos]="Los siguientes documentos sirven de evidencia para demostrar que los cuestionarios utilizados para la identificación y análisis de los factores de riesgo psicosociales son los que se encuentran en la guía de referencia II y III, cumpliendo con los métodos de evaluación descritos en esta.";
        break;
      }
      case "5.4 Adoptar las medidas para prevenir y controlar los factores de riesgo psicosocial":{
        this.titleCantidad[pos]="Para centros de trabajo con 50 o más colaboradores";
        this.IncisosUrl[pos]="incisoB";
        this.Incisos[pos]="b)	Información del cuestionario aplicado";
        this.DescripcionIncisos[pos]="Los siguientes documentos sirven de evidencia para demostrar que los cuestionarios utilizados para la identificación y análisis de los factores de riesgo psicosociales son los que se encuentran en la guía de referencia II y III, cumpliendo con los métodos de evaluación descritos en esta.";
        break;
      }
      case "5.1 a) La prevención de los factores de riesgo psicosocial":{
        this.titleCantidad[pos]="";
        this.IncisosUrl[pos]="incisoC";
        this.Incisos[pos]="c)	Información de las medidas de prevención de los factores de riesgo psicosocial";
        this.DescripcionIncisos[pos]="Los documentos que se enlistan a continuación contienen evidencia sobre las medidas adoptadas por el centro de trabajo para prevenir los factores de riesgo psicosociales ";
        break;
      }
      case "5.6 Practicar exámenes médicos y evaluaciones psicológicas":{
        this.titleCantidad[pos]="";
        this.Incisos[pos]="";
        this.DescripcionIncisos[pos]="";
        break;
      }
      case "5.1 b) La prevención de la violencia laboral hh":{
        this.titleCantidad[pos]="";
        this.Incisos[pos]="";
        this.DescripcionIncisos[pos]="";
        break;
      }
      case "5.1 b) La prevención de la violencia laboral jj":{
        this.titleCantidad[pos]="";
        this.Incisos[pos]="";
        this.DescripcionIncisos[pos]="";
        break;
      }
      case "5.1 b) La prevención de la violencia laboral":{
        this.titleCantidad[pos]="";
        this.IncisosUrl[pos]="incisoD";
        this.Incisos[pos]="d)	Información de las medidas de control adoptadas en el centro de trabajo";
        this.DescripcionIncisos[pos]="Los documentos que se enlistan a continuación contienen evidencia sobre las medidas de control adoptadas por el centro de trabajo";
        break;
      }
      case "5.1 c) La promoción de un entorno organizacional favorable":{
        this.titleCantidad[pos]="";
        this.IncisosUrl[pos]="incisoE";
        this.Incisos[pos]="e)	Información de las acciones adoptadas para identificar a los trabajadores";
        this.DescripcionIncisos[pos]="La evidencia que se anexa a continuación muestra información de los trabajadores identificados y las medidas adoptadas";
        break;
      }
        case "5.7 a) La política de prevención de riesgos psicosociales":{
          this.titleCantidad[pos]="";
          this.IncisosUrl[pos]="incisoF";
          this.Incisos[pos]="f)	Información de la atención brindada a los trabajadores expuestos ";
          this.DescripcionIncisos[pos]="La evidencia que se anexa a continuación muestra la atención médica proporcionada a los trabajadores expuestos";
        break;
      }
      case "5.7 b) Las medidas adoptadas para combatir las prácticas opuestas":{
        //
        this.titleCantidad[pos]="";
        this.IncisosUrl[pos]="incisoG";
        this.Incisos[pos]="g)	Información sobre la comunicación, difusión y proporcionar información de las medidas adoptadas y mecanismos para sobre la NOM-035-STPS-2018.";
        this.DescripcionIncisos[pos]="A continuación, se presenta la evidencia de las acciones realizadas por el centro de trabajo para comunicar, difundir";
        break;
      }
      case "5.7 c) Las medidas y acciones de prevención y, en su caso, las acciones ...":{
        this.titleCantidad[pos]="";
        this.IncisosUrl[pos]="incisoG";
        this.Incisos[pos]="h)	Registros de las acciones realizadas en los trabajadores";
        this.DescripcionIncisos[pos]="La ultima evidencia que se presenta está relacionada con los resultados de la identificación de los factores de riesgo psicosociales, las medidas adoptadas de este análisis y los trabajadores a los que se les practicaron los exámenes o evaluación correspondientes";

        break;
      }

   }


  }
  fecha:any;

  fechaDescarga:any;
  arregloTareas:any;
  arregloArchivos:any;
  newAttribute: any = {};
  rutaArchivos:any;
  rutaimagen:any;


  getImagenLogo(empresaPadre?:string){
    this.authService.getLogo(empresaPadre).subscribe( (data: backInter.getLogoEmpresa) => {
      if(data.message=="702"){
        let url = DATOS_API.url.split(":");
        this.rutaimagen= url[1]+"/surveyadministrator/backend/"+data.rutaArchivo;
      }
      else if(data.message=="701"){
       this.rutaimagen="assets/images/avatars/empIco.jpg";
        // console.log(data);
      }

    });
  }

  dataAcortador:any;


  reporteCT(){
    html2canvas(document.querySelector("#reporte")).then(canvas => {
      document.body.appendChild(canvas);
      var top_left_margin = 15;
      var contentWidth = canvas.width ;
      var contentHeight = canvas.height  ;
      var pageHeight = contentWidth / 592.28 * 841.89;
      var leftHeight = contentHeight-(top_left_margin*2);
      var position = 0;
      var imgWidth = 595.28;
      var imgHeight = (592.28/contentWidth * contentHeight) ;
      var pageData = canvas.toDataURL('image/jpeg', 1.0);

      var imgData =  this.rutaimagen; //'data:image/jpeg;base64,verylongbase64;'
      var pdf = new jspdf('', 'pt', 'letter');
      if (leftHeight < pageHeight) {
        pdf.addImage(pageData, 'JPEG', top_left_margin, top_left_margin, imgWidth, imgHeight );
      } else {
          while(leftHeight > 100 ) {
            imgHeight=imgHeight;
             var imgHeight = (592.28/contentWidth * contentHeight) ;
              pdf.addImage(pageData, 'JPEG', top_left_margin, position, imgWidth, imgHeight)
              leftHeight -= pageHeight;
              position -= 841.89;
              //Avoid adding blank pages
              if(leftHeight > 100) {
                pdf.addPage();
              }
          }
      }
      pdf.save('Reporte_evidencias_NOM035_'+this.nombreCT+'.pdf');
  });
  }

  trymargin(){
    const pdf = new jspdf('p', 'pt', 'a4'); // For A4 Sheet layout
pdf.addHTML(document.getElementById('reporte'), 25, 50, {
    retina: true,
    pagesplit: true,
    margin: {
      top: 50,
      right: 25,
      bottom: 50,
      left: 25,
      useFor: 'page' // This property is mandatory to keep the margin to supsequent pages
    }
  }, function() {
    pdf.save('test.pdf');
  });



  }

  getPDF(){
    html2canvas(document.querySelector("#reporte")).then(canvas => {
      document.body.appendChild(canvas);
      var HTML_Width = canvas.width ;
		  var HTML_Height = canvas.height;
		  var top_left_margin = 15;
		  var PDF_Width = HTML_Width+(top_left_margin*2);
		  var PDF_Height = (PDF_Width*1.5)+(top_left_margin*2);
		  var canvas_image_width = HTML_Width;
		  var canvas_image_height = HTML_Height;
		  var totalPDFPages = Math.ceil(HTML_Height/PDF_Height)-1;


		html2canvas($(".reporte")[0],{allowTaint:true}).then(function(canvas) {
			canvas.getContext('2d');

			console.log(canvas.height+"  "+canvas.width);


			var imgData = canvas.toDataURL("image/jpeg", 1.0);
			var pdf = new jspdf('p', 'pt',  [PDF_Width, PDF_Height]);
		    pdf.addImage(imgData, 'JPG', top_left_margin, top_left_margin,canvas_image_width,canvas_image_height);


			for (var i = 1; i <= totalPDFPages; i++) {
				pdf.addPage(PDF_Width, PDF_Height);
				pdf.addImage(imgData, 'JPG', top_left_margin, -(PDF_Height*i)+(top_left_margin*4),canvas_image_width,canvas_image_height);
			}

		    pdf.save("HTML-Document.pdf");
        });
    });


	};










}
